/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LogicalOperator = {
    Or: 'OR',
    And: 'AND'
} as const;
export type LogicalOperator = typeof LogicalOperator[keyof typeof LogicalOperator];


export function instanceOfLogicalOperator(value: any): boolean {
    for (const key in LogicalOperator) {
        if (Object.prototype.hasOwnProperty.call(LogicalOperator, key)) {
            if (LogicalOperator[key as keyof typeof LogicalOperator] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LogicalOperatorFromJSON(json: any): LogicalOperator {
    return LogicalOperatorFromJSONTyped(json, false);
}

export function LogicalOperatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogicalOperator {
    return json as LogicalOperator;
}

export function LogicalOperatorToJSON(value?: LogicalOperator | null): any {
    return value as any;
}

export function LogicalOperatorToJSONTyped(value: any, ignoreDiscriminator: boolean): LogicalOperator {
    return value as LogicalOperator;
}

